import { Component, input } from '@angular/core';

@Component({
  selector: 'app-pan-button-group, [panButtonGroup]',
  templateUrl: './pan-button-group.component.html',
  styleUrl: './pan-button-group.component.scss',
  standalone: false,
})
export class PanButtonGroupComponent {
  public ariaLabel = input<string>('Button Group');
}
